import { HttpClient } from 'api/http-client';
import { Role } from 'api/models';
import { TeamsAPI } from 'api/teams';

class RoleClient extends HttpClient {
  public create(payload: AtLeast<Role, 'roleName'>): Promise<Role> {
    return this.post('/roles', payload);
  }

  public update(
    roleId: number,
    payload: AtLeast<Role, 'roleName'>,
  ): Promise<Role> {
    return this.put(`/roles/${roleId}`, payload);
  }

  public deleteRole(roleId: number): Promise<Role> {
    return this.delete(`/roles/${roleId}`);
  }

  public async createWithDefaultPlaceholder(
    payload: AtLeast<Role, 'roleName'>,
  ): Promise<Role> {
    const role: Role = await this.post('/roles', payload);

    await TeamsAPI.createTeam({
      teamName: role.roleName,
      roleId: role.roleId,
    });

    return role;
  }

  public findAll(): Promise<Role[]> {
    return this.get('/roles');
  }

  public findAllWithToken(token: string): Promise<Role[]> {
    return this.get(`/roles?token=${token}`);
  }

  public makeRolesAvailableForPartner = (roleIds: number[]) =>
    this.put(
      '/roles/bulk',
      roleIds.map((id) => ({ roleId: id })),
    );
}

export const RolesApi = new RoleClient();
